'use strict'
module.exports = {
  NODE_ENV: '"production"',
  API: '"https://cortinasonline.com/api/v1/"',
  MP_TOKEN: 'APP_USR-9ecdfa42-8f3e-4b73-beca-d67e37c3fe61'
  //MP_TOKEN: 'APP_USR-a2070f1d-05c0-478a-9b31-d32259445f56'
}



//////////////////
// WEBPACK FOOTER
// ./config/prod.env.js
// module id = rBKV
// module chunks = 15